module.exports = __webpack_public_path__ + "img/coffee vector.db3a1757.svg";